const esCreateFile: Record<string, { message: string; description: string }> = {
  "ledgerEditor.nameYourFile": {
    message: "Nombre your file...",
    description: "Placeholder for file name input",
  },
};

export default esCreateFile;
